import { createSelector } from "@reduxjs/toolkit";

export const tabsSelector = (state) => state.tabs;
export const submissionTabsSelector = createSelector(
  [tabsSelector],
  (tabs) => tabs.submission
);

export const ES_DataSelector = createSelector(
  [submissionTabsSelector],
  (tabs) => tabs.find((tab) => tab.active && tab.name === "submission")
);

export const sidebarSelector = createSelector(
  [tabsSelector],
  (tabs) => tabs.sidebar
);

// patients Selectors
export const patientTabsSelector = createSelector(
  [tabsSelector],
  (tabs) => tabs.patients
);
export const patientSearchSelector = createSelector(
  [patientTabsSelector],
  (tabs) => tabs.find((tab) => tab.id === 0 && tab.active)
);



// insurancePayment Selectors
export const InsuranceTabSelector = createSelector(
  [tabsSelector],
  (tabs) => tabs.insurancePayment
);

// mainTab Selectors
export const mainTab = createSelector([tabsSelector], (tabs) => tabs.mainTab); 
